
//只有钻石只有戒托只有这两个可点击    钻石戒托都存在走到第三步三个都可点击
let productTag = document.querySelector('.initHanle');
let settingData = sessionStorage.getItem('settingData');
let diamondData = sessionStorage.getItem('diamondData');
let collectionsName = productTag.dataset?.progresshandle;
let tagName = productTag.dataset?.progresstag;
let stepArray = document.querySelectorAll('.stepItem');
let currentStep = sessionStorage.getItem('currentStep');
let stepCanClick;
// step1
let step1 = stepArray[0];
let step1Href = stepArray[0].querySelector('.step-href');
let step1Text = stepArray[0].querySelector('.step-text');
let step1Desc = stepArray[0].querySelector('.step-desc');
let step1Icon = stepArray[0].querySelector('.step-icon');
let step1Price = stepArray[0].querySelector('.step-price');
let line1Price = stepArray[0].querySelector('.line-price');
let step1View = stepArray[0].querySelector('.step-viewBox');
let step1ViewLink = stepArray[0].querySelector('.step-view');
let step1Change = stepArray[0].querySelector('.step-change');
let step1Img = stepArray[0].querySelector('.step-image');
let progressStepText1 = stepArray[0].querySelector('.progress-step-text');

// step2
let step2 = stepArray[1];
let step2Href = stepArray[1].querySelector('.step-href');
let step2Text = stepArray[1].querySelector('.step-text');
let step2Desc = stepArray[1].querySelector('.step-desc');
let step2Icon = stepArray[1].querySelector('.step-icon');
let step2Price = stepArray[1].querySelector('.step-price');
let line2Price = stepArray[1].querySelector('.line-price');
let step2View = stepArray[1].querySelector('.step-viewBox');
let step2ViewLink = stepArray[1].querySelector('.step-view');
let step2Change = stepArray[1].querySelector('.step-change');
let step2Img = stepArray[1].querySelector('.step-image');
let progressStepText2 = stepArray[1].querySelector('.progress-step-text');

if (!diamondData && !settingData) {
    // 判断谁是第一位根据集合名
    if (collectionsName == 'engagement-rings-v2' || tagName?.includes('Engagement Ring V2')) {
        step1Text.textContent = 'Settings';
        step1Desc.textContent = 'Choose your Settings';
        step1Href.setAttribute('href', '/collections/engagement-rings-v2');
        step1Icon.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0756/6393/3752/files/setting.svg?v=1720175563');
        document.querySelector('.progress-step-text').style.color = '#75533A';
        // 
        step2Href.setAttribute('href', '/collections/loose-stones-v2');
        step2Text.textContent = 'Diamond';
        step2Desc.textContent = 'Choose your Diamond';
        step2Icon.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0756/6393/3752/files/diamond.svg?v=1720175555');
    }
    if (collectionsName == 'loose-stones-v2' || tagName?.includes('Loose Stone V2')) {
        step1Text.textContent = 'Diamond';
        step1Desc.textContent = 'Choose your Diamond';
        step1Href.setAttribute('href', '/collections/loose-stones-v2');
        step1Icon.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0756/6393/3752/files/diamond.svg?v=1720175555');
        step1.style.border = '1px solid #75533A'
        document.querySelector('.progress-step-text').style.color = '#75533A';

        // 
        step2Href.setAttribute('href', '/collections/engagement-rings-v2');
        step2Text.textContent = 'Settings';
        step2Desc.textContent = 'Choose your Settings';
        step2Icon.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0756/6393/3752/files/setting.svg?v=1720175563');
    }
    const stepTrue = [...stepArray];
    stepTrue.forEach((item, index) => {
        item.style.background = "#F9F9F9";
        if (index == 0) {
            item.style.border = '1px solid #75533A'
        }
        if (index == 0 || index == 1) {
            item.addEventListener('click', function () {
                let link = item.querySelector('.step-href');
                console.log(`click${index}`);
                stepTrue.forEach((item, index) => {
                    item.style.background = "#F9F9F9";
                    item.style.border = 'none'
                    item.querySelector('.progress-step-text').style.color = '#161B22';
                });
                item.querySelector('.progress-step-text').style.color = '#75533A';
                item.style.border = '1px solid #75533A'
                window.location.href = link.href
            });
        }
    })


} else if (diamondData && settingData) {
    // sessionStorage.setItem("currentStep", 2)
    let firstStep = sessionStorage.getItem('fisrtStep');
    if (collectionsName == "engagement-rings-v2" || collectionsName == "loose-stones-v2") {
        if (currentStep == 2 && !location.pathname.includes('collections')) {
            window.location.href = '/collections/completering';
        }
    }
    if (firstStep === "Settings") {
        // 只有前两个可点击
        step1Text.textContent = 'Settings';
        step1Desc.textContent = 'Choose your Settings';
        step1Href.setAttribute('href', '/collections/engagement-rings-v2');
        // step1Icon.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0756/6393/3752/files/setting.svg?v=1720175563');
        step1Icon.style.display = 'none';
        step1View.style.display = 'flex';
        step1Price.textContent = JSON.parse(settingData)?.priceStr;
        line1Price.textContent = JSON.parse(settingData)?.discountPrice?`$${JSON.parse(settingData)?.discountPrice}`:null;

        step1Img.setAttribute('src', JSON.parse(settingData)?.imgStr)
        step1ViewLink.setAttribute('href', JSON.parse(settingData)?.code)
        step1Change.addEventListener('click', function (event) {
            event.preventDefault();
            sessionStorage.removeItem('settingData');
            sessionStorage.removeItem('egSetting');
            window.location.href = "/collections/engagement-rings-v2";
        });

        // step2
        step2Text.textContent = 'Diamond';
        step2Desc.textContent = 'Choose your Diamond';
        step2Href.setAttribute('href', '/collections/loose-stones-v2');
        // step1Icon.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0756/6393/3752/files/diamond.svg?v=1720175555');
        step2Icon.style.display = 'none';
        step2View.style.display = 'flex';
        step2Price.textContent = JSON.parse(diamondData)?.priceStr;
        line2Price.textContent = parseInt(JSON.parse(diamondData)?.discountPrice)?`$${parseInt(JSON.parse(diamondData)?.discountPrice)}`:null;

        step2Img.setAttribute('src', JSON.parse(diamondData)?.imgStr)
        step2ViewLink.setAttribute('href', JSON.parse(diamondData)?.code)
        step2Change.addEventListener('click', function (event) {
            event.preventDefault();
            sessionStorage.removeItem('diamondData');
            sessionStorage.removeItem('egDiamond');
            window.location.href = "/collections/loose-stones-v2";
        });
    } else {
        step1Text.textContent = 'Diamond';
        step1Desc.textContent = 'Choose your Diamond';
        step1Href.setAttribute('href', '/collections/loose-stones-v2');
        // step1Icon.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0756/6393/3752/files/diamond.svg?v=1720175555');
        step1Icon.style.display = 'none';
        step1View.style.display = 'flex';
        step1Price.textContent = JSON.parse(diamondData)?.priceStr;
        line1Price.textContent = JSON.parse(settingData)?.discountPrice?`$${JSON.parse(settingData)?.discountPrice}`:null;

        step1Img.setAttribute('src', JSON.parse(diamondData)?.imgStr)
        step1ViewLink.setAttribute('href', JSON.parse(diamondData)?.code)
        step1Change.addEventListener('click', function (event) {
            event.preventDefault();
            sessionStorage.removeItem('diamondData');
            sessionStorage.removeItem('egDiamond');
            window.location.href = "/collections/loose-stones-v2";
        });
        // step2
        step2Text.textContent = 'Settings';
        step2Desc.textContent = 'Choose your Settings';
        step2Href.setAttribute('href', '/collections/engagement-rings-v2');
        // step1Icon.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0756/6393/3752/files/setting.svg?v=1720175563');
        step2Icon.style.display = 'none';
        step2View.style.display = 'flex';
        step2Price.textContent = JSON.parse(settingData)?.priceStr;
        line2Price.textContent = parseInt(JSON.parse(diamondData)?.discountPrice)?`$${parseInt(JSON.parse(diamondData)?.discountPrice)}`:null;



        step2Img.setAttribute('src', JSON.parse(settingData)?.imgStr)
        step2ViewLink.setAttribute('href', JSON.parse(settingData)?.code)
        step2Change.addEventListener('click', function (event) {
            event.preventDefault();
            sessionStorage.removeItem('settingData');
            sessionStorage.removeItem('egSetting');
            window.location.href = "/collections/engagement-rings-v2";
        });
    }

    const stepTrue = [...stepArray];
    stepTrue.forEach((item, index) => {
        item.style.background = "#F9F9F9";
        console.log(currentStep, index, 'huhu1');
        if (currentStep == index) {
            item.style.border = '1px solid #75533A';
            item.querySelector('.progress-step-text').style.color = '#75533A';
        }
        item.addEventListener('click', function () {
            stepTrue.forEach((item, index) => {
                item.style.background = "#F9F9F9";
                item.style.border = 'none';
                item.querySelector('.progress-step-text').style.color = '#161B22';
            });
            sessionStorage.setItem("currentStep", index)
            item.style.border = '1px solid #75533A'
            item.querySelector('.progress-step-text').style.color = '#75533A';
            if (index == 2) {
                window.location.href = `/collections/completering`
                return
            }

            let link = item.querySelector('.step-href');
            window.location.href = link.href
        });
    })
    console.log(firstStep, 'firstStepfirstStepfirstStep');
} else if (!diamondData && settingData) {
    // 只有前两个可点击
    step1Text.textContent = 'Settings';
    step1Desc.textContent = 'Choose your Settings';
    step1Href.setAttribute('href', '/collections/engagement-rings-v2');
    // step1Icon.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0756/6393/3752/files/setting.svg?v=1720175563');
    step1Icon.style.display = 'none';
    step1View.style.display = 'flex';
    step1Price.textContent = JSON.parse(settingData)?.priceStr;
    line1Price.textContent = JSON.parse(settingData)?.discountPrice?`$${JSON.parse(settingData)?.discountPrice}`:null;

    step1Img.setAttribute('src', JSON.parse(settingData)?.imgStr)
    step1ViewLink.setAttribute('href', JSON.parse(settingData)?.code)
    step1Change.addEventListener('click', function (event) {
        event.preventDefault();
        sessionStorage.removeItem('settingData');
        sessionStorage.removeItem('egSetting');
        window.location.href = "/collections/engagement-rings-v2";
    });
    // step2
    step2Href.setAttribute('href', '/collections/loose-stones-v2');
    step2Text.textContent = 'Diamond';
    step2Desc.textContent = 'Choose your Diamond';
    step2Icon.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0756/6393/3752/files/diamond.svg?v=1720175555');

    step2.style.border = '1px solid #75533A'
    progressStepText2.style.color = '#75533A';

    // 只有前两个可点击

    const stepTrue = [...stepArray];
    stepTrue.forEach((item, index) => {
        item.style.background = "#F9F9F9";
        console.log(currentStep, "currentStep");
        if (!currentStep && index == 1) {
            item.style.border = '1px solid #75533A'
        }
        if (index == 0 || index == 1) {
            if (currentStep && index == currentStep) {
                // item.style.border = '1px solid #75533A'
            }
            item.addEventListener('click', function () {
                let link = item.querySelector('.step-href');
                console.log(`click${index}`);
                stepTrue.forEach((item, index) => {
                    item.style.background = "#F9F9F9";
                    item.style.border = 'none';
                    item.querySelector('.progress-step-text').style.color = '#75533A';
                    item.querySelector('.progress-step-text').style.color = '#161B22';
                });
                sessionStorage.setItem("currentStep", index)
                item.style.border = '1px solid #75533A';
                item.querySelector('.progress-step-text').style.color = '#75533A';
                window.location.href = link.href
            });
        }
    })
    sessionStorage.setItem('fisrtStep', 'Settings')

} else if (diamondData && !settingData) {
    step1Text.textContent = 'Diamond';
    step1Desc.textContent = 'Choose your Diamond';
    step1Href.setAttribute('href', '/collections/loose-stones-v2');
    // step1Icon.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0756/6393/3752/files/diamond.svg?v=1720175555');
    step1Icon.style.display = 'none';
    step1View.style.display = 'flex';
    step1Price.textContent = JSON.parse(diamondData)?.priceStr;
    line1Price.textContent = JSON.parse(settingData)?.discountPrice?`$${JSON.parse(settingData)?.discountPrice}`:null;;


    step1Img.setAttribute('src', JSON.parse(diamondData)?.imgStr)
    step1ViewLink.setAttribute('href', JSON.parse(diamondData)?.code)
    step1Change.addEventListener('click', function (event) {
        event.preventDefault();
        sessionStorage.removeItem('diamondData');
        sessionStorage.removeItem('egDiamond');
        window.location.href = "/collections/loose-stones-v2";
    });
    // step2
    step2Href.setAttribute('href', '/collections/engagement-rings-v2');
    step2Text.textContent = 'Settings';
    step2Desc.textContent = 'Choose your Settings';
    step2Icon.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0756/6393/3752/files/setting.svg?v=1720175563');

    step2.style.border = '1px solid #75533A'
    progressStepText2.style.color = '#75533A';

    // 只有前两个可点击

    const stepTrue = [...stepArray];
    stepTrue.forEach((item, index) => {
        item.style.background = "#F9F9F9";
        console.log(currentStep, "currentStep");
        if (!currentStep && index == 1) {
            item.style.border = '1px solid #75533A'
        }
        if (index == 0 || index == 1) {
            if (currentStep && index == currentStep) {
                // item.style.border = '1px solid #75533A'
            }
            item.addEventListener('click', function () {
                let link = item.querySelector('.step-href');
                console.log(`click${index}`);
                stepTrue.forEach((item, index) => {
                    item.style.background = "#F9F9F9";
                    item.style.border = 'none';
                    item.querySelector('.progress-step-text').style.color = '#161B22';
                });
                sessionStorage.setItem("currentStep", index)
                item.style.border = '1px solid #75533A';
                item.querySelector('.progress-step-text').style.color = '#75533A';
                window.location.href = link.href
            });
        }
    })

    sessionStorage.setItem('fisrtStep', 'diamond')
}